/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from 'vue-property-decorator'
import {menuBtn} from '@/utils/menu_level2_button'
import {getFinanceInvoiceById, setFinanceInvoiceById, getOrderListOrMarketCoopetationId,getCompanyList,getFinanceInvoiceContent} from '@/api/financial-center'
import {UserModule} from '@/store/modules/user'
import {formatDate} from '@/utils/timeFilter'
import {getDepartmentByUserId} from '@/api/common'
import {delNullProperty} from '@/utils/index'
import * as math from 'mathjs'
@Component({})
export default class MakeInvoiceInfo extends Vue {
    tableKey = Math.random()
    isShow = "" //为1已通过可以编辑本次回款金额
    invoiceNumTitle = ""  //订单/回款编号
    errorDialogShow = false
    formOptions = new Array(0)
    arr_form = new Array(0)
    invoiceId = NaN
    invoiceList: any = {}
    tableData = []
    showInput: any = false
    receivingAccount = []
    pageType: any = 1
    logList = []
    status: any = ''
    submitButtonDisabled = false
    cancelTabkBackClueDialog: any = false
    cancelTabkBackRepeatDialog: any = false
    saveType: any = 1
    repeatDialog: any = false
    repeatDetailList: any = []
    repeatStudentName: any = false
    repeatStudentIphone: any = false
    repeatStudentWeixin: any = false
    repeatStudentNameList: any = []
    repeatStudentIphoneList: any = []
    repeatStudentWeixinList: any = []
    formRules = {
        account: [{required: true, message: '请选择收款账户', trigger: 'change'}],
        isProof: [{required: true, message: '请选择是否生成凭证', trigger: 'change'}],
        title: [{required: true, message: '请输入开票抬头', trigger: 'blur'}],
        invocieCode: [{required: true, message: '请输入纳税识别号', trigger: 'blur'}],
        bank: [{required: true, message: '请输入开户行', trigger: 'blur'}],
        invoiceAccount: [{required: true, message: '请输入开户账号', trigger: 'blur'}],
        address: [{required: true, message: '请输入开票地址', trigger: 'blur'}],
        phone: [{required: true, message: '请输入电话', trigger: 'blur'}],
        directorUserId: [{required: true, message: '请选择负责人', trigger: 'change'}],
        content: [{required: true, message: '请选择开票内容', trigger: 'change'}],
        email: [{required: true, message: '请输入发票接收邮箱', trigger: ['blur','change']}],
        titleTypes: [{required: true, message: '请选择抬头类型', trigger: 'change'}],
        types: [{required: true, message: '请选择开票类型', trigger: ['blur','change']}],
    }
    rules2 = {}
    maxPrice = null
    formData: any = {
        content: '', //开票内容
        invoiceAt: '', //财务开票时间
        thisTimePrice: null,
        financeInvoiceDetailList: [],  //操作日志
        id: null,
        account: null,
        invoiceAccount: null,
        isProof: null,
        remark: '',
        directorUserId: null,
        types: null,
        title: null,
        code: null,
        bank: null,
        address: null,
        phone: null,
        invocieCode: null,
        email: null, // 发票接收邮箱

        name: null,
        sourceType: null,
        marketChannelId: null,
        source: null,
        realName: null,
        gender: null,
        // email: null,
        weChat: null,
        attendSchool: null,
        grade: null,
        specialized: null,
        parentName: null,
        parentPhone: null,
        parentWeChat: null,
        targetSchool: null,
        achievement: null,
        feedback: null,
        createdAt: new Date(),
        createdUserRealName: null,
        customerBusinessDataList: [],
        isDraft: '0'
    }
    sourceList: any = [
        {name: '合作伙伴', val: '0'},
        {name: '市场渠道', val: '1'},
        {name: '其它', val: '2'},
    ]
    sourceChildList: any[] = []
    operationShow = true
    type = ""
    isUpdatedData = '0'

    orderDialog = false  //订单列表
    orderDialogInputValue = ''
    orderDialogTaleData = []
    orderDialogTotal = 0
    orderDialogPage = 1
    orderDialogTableLoading = false
    orderDialogSelectTable = []

    receivableDialog = false //回款列表
    receivableDialogInputValue = ''
    receivableDialogTaleData = []
    receivableDialogTotal = 0
    receivableDialogPage = 1
    receivableDialogTableLoading = false
    receivableConfirmList = {
        financeBackMoneyCode: '',
        directorUserRealName: '',
        financeBackMoneyId: '',
        financeBackMoneyPrice: '',
        financeInvoiceDetailList: [],
        mainPartName: '',
        price: '',
        surplusInvoicePrice: '',
    }

    receivableDialogSelectTable = {
        financeBackMoneyCode: '',
        directorUserRealName: '',
        financeBackMoneyId: '',
        financeBackMoneyPrice: '',
        financeInvoiceDetailList: [],
        mainPartName: '',
        price: '',
        surplusInvoicePrice: '',
        companyName :'' // 收款账户
    }
    select = '1'  //订单/回款列表筛选
    limit = 20
    loading = false
    activities = []
    pagesize = 20
    disableBtn = false
    makeInvoiceContent = [
        // {label:'课程服务费',value:'0'},
        // {label:'教育服务培训费',value:'1'},
        // {label:'培训费',value:'2'},
        // {label:'培训服务费',value:'3'},
        // {label:'教育咨询服务费',value:'4'}
    ]
    statusbyget = ''
    contentName = ''   // 开票内容

    formatDate = formatDate
    menuBtn = menuBtn

    created() {
        this.invoiceId = Number(this.$route.query.id)
        this.status = this.$route.query.status
        this.type = this.$route.query.type as string
        if (this.$route.query.isUpdatedData) {
            this.isUpdatedData = this.$route.query.isUpdatedData as string
        }
        if (this.type) {
            this.showInput = true
        }
        this.getFinanceInvoiceById()
        this.getCompanyList()
    }

    get UserName() {
        return UserModule.userName
    }

    get userList() {
        return UserModule.userList
    }

    get userId() {
        return UserModule.userId
    }

    get orderAllPrice() {
        let num = 0
        if (this.tableData) {
            this.tableData.map(item =>
                num = math.number(math.add(math.bignumber(num), math.bignumber(item.thisTimePrice ? Number(item.thisTimePrice) : 0)))
            )
        }
        return num
    }


    // 明细删除
    clickDelOrder(row) {
        this.tableData = this.tableData.filter((item =>
                item.financeOrderId !== row.financeOrderId
        ))
        if (this.tableData && this.tableData.length > 0) {
            let num = 0
            this.tableData.forEach(item => {
                // 订单金额 - 已开票金额
                let val = math.number(math.subtract(math.bignumber(item.financeOrderPrice), math.bignumber(item.financeInvoicePrice)))
                num = math.number(math.add(math.bignumber(num), math.bignumber(val)))
            })
            this.formData.surplusInvoicePrice = num
        } else {
            this.formData.surplusInvoicePrice = 0
        }
    }

    // 开票账户
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.receivingAccount = data.companyList
        this.receivingAccount.forEach(item => {
            if (item.name == '北京集思互联教育科技有限公司' || item.name == '上海恒艾教育科技有限公司' || item.name == '北京昌意科技有限公司') {
                item.disabled = false
            } else {
                item.disabled = true
            }
        })
    }
    // 开票明细导出
    exportExcelData(res) {
        require.ensure([], () => {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const {export_json_to_excel} = require('../../../../vender/Export2Excel.js')
            const tHeader = ['订单编号', '学生名称', '项目名称', '项目类型', '开课时间', '已开票金额', '订单金额', '回款金额', '本次开票金额']
            const filterVal = ['financeOrderCode', 'customerName', 'souCourseName', 'souCourseType', 'souCourseSchoolBegin', 'financeInvoicePrice', 'financeOrderPrice', 'financeBackMoneyPrice', 'thisTimePrice']
            const list = this.tableData
            const data = this.formatJson(filterVal, list)
            export_json_to_excel(tHeader, data, '开票明细')
        })
    }

    formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
    }

    // 开票明细计算总价
    getSummaries(param: any) {
        const {columns, data} = param;
        const sums: any = [];
        columns.forEach((column: any, index: number) => {
            if (index === 0) {
                sums[index] = '总计';
                // return;
            } else if (index === 7) {
                const values = data.map((item: any) => Number(item[column.property]));
                if (column.property === 'thisTimePrice') {
                    sums[index] = values.reduce((prev: any, curr: any) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return Math.round(((Math.floor(prev * 100) / 100 + Math.floor(curr * 100) / 100) * 100)) / 100;
                        } else {
                            return prev;
                        }
                    }, 0)
                }
            } else {
                sums[index] = '';
            }
        });
        return sums;
    }

    onExchangeChange(index) {
        const tmpObj = this.tableData[index];
        this.$set(this.tableData, index, tmpObj);
    }

    handleOninput(num, limit) {
        let str = num
        const len1 = str.substr(0, 1)
        const len2 = str.substr(1, 1)
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
            str = str.substr(1, 1)
        }
        //第一位不能是.
        if (len1 == ".") {
            str = ""
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
            const str_ = str.substr(str.indexOf(".") + 1)
            if (str_.indexOf(".") != -1) {
                str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1)
            }
        }
        //正则替换
        str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
        if (limit / 1 === 1) {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,1})?.*$/, '$1') // 小数点后只能输 1 位
        } else {
            str = str.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/, '$1') // 小数点后只能输 2 位
        }
        return str
    }

    //  订单、回款编号列表
    async getOrderListOrMarketCoopetationId() {
        this.loading = true
        const obj = {
            mainPart: this.formData.mainPart == '合作伙伴' ? '1' : '0',  //开票主体 允许值: 0-学生, 1-合作伙伴
            page: this.formData.basis == '订单编号' ? this.orderDialogPage : this.receivableDialogPage,
            limit: this.pagesize,
            basis: this.formData.basis == '订单编号' ? '0' : '1',   //开票依据 允许值: 0-订单编号, 1-回款编号
            customerId: this.formData.mainPart == '学生' ? Number(this.formData.customerId) : Number(''), //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '学生' ? String(this.formData.customerType) : '',  //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '合作伙伴' ? Number(this.formData.marketCooperationId) : Number(''),  //合作伙伴id // 当mainPart = 1时必需
            code: this.select == '订单/回款编号' ? this.orderDialogInputValue : '',   //订单/回款编号
        }
        // for (const key in obj) {
        //     if (obj[key].length === 0 || !obj[key]) {
        //         delete obj[key]
        //     }
        // }

        const data: any = await getOrderListOrMarketCoopetationId(delNullProperty(obj))
        if (this.formData.basis == '订单编号' || this.formData.basis == '1') {
            this.orderDialogTaleData = data.resultList
            this.orderDialogTotal = data.allNum
            this.orderDialogTableLoading = false
        }
        if (this.formData.basis == '回款编号' || this.formData.basis == '0') {
            this.receivableDialogTaleData = data.resultList
            this.receivableDialogTotal = data.allNum
            this.receivableDialogTableLoading = false
        }
        if (this.isShow == '1') {
            this.tableData.map(item => {
                data.resultList.map(items => {
                    if (item.financeOrderId == items.financeOrderId) {
                        const data = items.financeInvoiceDetailList[0]
                        item.surplusInvoicePrice = Number(item.financeOrderPrice) - Number(item.financeInvoicePrice)
                        items.surplusInvoicePrice = Number(data.financeOrderPrice) - Number(data.financeInvoicePrice)
                        // item.oldThisBackMoney = this.isShow == '1' ? item.price : 0,
                        // item.oldSurMoney = this.isShow == '1' ? item.surplusInvoicePrice : 0
                    }
                })
            })
        }
        this.loading = false
    }

    // 编辑添加订单
    clickAddOrder() {
        if (this.formData.basis == '订单编号' || this.formData.basis == '1') {
            this.orderDialog = true
            this.orderDialogPage = 1
            this.orderDialogInputValue = ''
        }
        if (this.formData.basis == '回款编号' || this.formData.basis == '0') {
            this.receivableDialogPage = 1
            this.receivableDialogInputValue = ''
            this.receivableDialog = true
        }
        this.getOrderListOrMarketCoopetationId()
        this.defaultChecked()
    }

    // 订单
    handleOrderRowClick(row) {
        if (row.surplusInvoicePrice > 0) { //可勾选
            (this.$refs.orderDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }

    getRowKeys(row) {
        return `${row.customerId}${row.customerType}`
    }

    // 订单列表change
    orderDialogSelectionChange(selectionArr: any[]) {
        // 订单如果主体为合作伙伴可以多选 学生单选
        if (this.formData.mainPart == '学生' || this.formData.mainPart == '0') {  //学生
            if (selectionArr.length > 0) {
                this.orderDialogSelectTable = selectionArr
                if (selectionArr.length > 1) {
                    const orderTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderTable.clearSelection()
                    orderTable.toggleRowSelection(selectionArr.pop()) //pop() 方法用于删除并返回数组的最后一个元素。
                }
            } else {
                this.orderDialogSelectTable = []
            }
        } else if (this.formData.mainPart == '合作伙伴' || this.formData.mainPart == '1') {  //合作伙伴
            // this.orderDialogSelectTable = selectionArr
            // if(this.tableData.length > 0){
            //     this.tableData.map(item => {
            //         this.orderDialogSelectTable.map(items => {
            //             if(item.financeOrderId == items.financeOrderId) {
            //                 items.thisTimePrice = item.thisTimePrice
            //             }
            //         })
            //     })
            // }
            //
            this.orderDialogSelectTable = selectionArr
        }
    }

    defaultChecked() {
        this.$nextTick(() => {
            const order = (this.$refs.orderDialogTable as HTMLFormElement)
            const backMoney = (this.$refs.receivableDialogTable as HTMLFormElement)
            if (this.formData.basis == '回款编号' || this.formData.basis == '0') {
                backMoney.clearSelection();
                this.tableData.forEach(row => {
                    backMoney.toggleRowSelection(row, true)
                })
            } else {
                order.clearSelection();
                this.tableData.forEach(row => {
                    order.toggleRowSelection(row, true)
                })
            }
        })
    }

    // 订单编号列表搜索
    async clickOrderDialogFilter() {
        this.orderDialogPage = 1
        this.orderDialogTableLoading = true
        const obj = {
            mainPart: this.formData.mainPart == '合作伙伴' ? '1' : '0',   //开票主体 允许值: 0-学生, 1-合作伙伴
            page: this.orderDialogPage,
            limit: this.pagesize,
            basis: this.formData.basis == '订单编号' ? '0' : '1',   //开票依据 允许值: 0-订单编号, 1-回款编号
            customerId: this.formData.mainPart == '学生' ? Number(this.formData.customerId) : Number(''),  //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '学生' ? String(this.formData.customerType) : '',   //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '合作伙伴' ? Number(this.formData.marketCooperationId) : Number(''),   //合作伙伴id // 当mainPart = 1时必需
            code: this.select == '1' ? this.orderDialogInputValue : '',   //订单/回款编号
            customerName: this.select == '0' ? this.orderDialogInputValue : '',   //订单/回款编号
        }
        for (const key in obj) {
            if (obj[key] == '' || !obj[key]) {
                delete obj[key]
            }
        }
        const data: any = await getOrderListOrMarketCoopetationId(obj)
        this.orderDialogTaleData = data.resultList
        this.orderDialogTotal = data.allNum
        this.orderDialogTableLoading = false
    }

    // 回款编号列表搜索
    async clickReceivableDialogFilter() {

        this.receivableDialogPage = 1
        this.receivableDialogTableLoading = true
        const obj = {
            mainPart: this.formData.mainPart == '合作伙伴' ? '1' : '0',   //开票主体 允许值: 0-学生, 1-合作伙伴
            page: this.receivableDialogPage,
            limit: this.receivableDialogTotal,
            basis: this.formData.basis == '订单编号' ? '0' : '1',   //开票依据 允许值: 0-订单编号, 1-回款编号
            customerId: this.formData.mainPart == '学生' ? Number(this.formData.customerId) : Number(''),  //客户id // 当mainPart = 0时必需
            customerType: this.formData.mainPart == '学生' ? String(this.formData.customerType) : '',   //客户类型 // 当mainPart = 0时必需 允许值: 'customerConversion-转化客户', 'customerBusiness-B端客户'
            marketCooperationId: this.formData.mainPart == '合作伙伴' ? Number(this.formData.marketCooperationId) : Number(''),   //合作伙伴id // 当mainPart = 1时必需
            code: this.receivableDialogInputValue,   //订单/回款编号
        }
        const data: any = await getOrderListOrMarketCoopetationId(delNullProperty(obj))
        this.receivableDialogTaleData = data.resultList
        this.receivableDialogTableLoading = false
    }

    // 订单确认事件
    orderDialogConfirm() {
        let num = 0
        this.orderDialogSelectTable.map(item => num += Number(item.surplusInvoicePrice ? item.surplusInvoicePrice : 0))

        const newArr = []
        this.tableData.map(i => {
            this.orderDialogSelectTable.map(j => {
                if (j.financeOrderId === i.financeOrderId) {
                    newArr.push(i)
                }
            })
        })
        this.tableData = newArr
        let allThisOrder = 0
        this.orderDialogSelectTable.map(item => {
            const Index = this.tableData.findIndex((items) => {
                return items.financeOrderId === item.financeOrderId
            })
            if (Index == -1) {
                item.financeInvoiceDetailList.map(itemss => {
                    const thisTimePrice = Number(itemss.financeOrderPrice) - Number(itemss.financeInvoicePrice)
                    allThisOrder += thisTimePrice
                    this.tableData.push({
                        ...itemss,
                        // oldThisBackMoney: this.isShow == '1' ? itemss.financeOrderPrice : 0,
                        // oldSurMoney: this.isShow == '1' ? itemss.financeOrderPrice : 0,
                        thisTimePrice: thisTimePrice,
                    })
                })
            }
        })
        this.formData.surplusInvoicePrice = num - allThisOrder    //可开票金额
        // this.tableData.map(item => num += Number(item.surplusInvoicePrice ? item.surplusInvoicePrice : 0))
        // this.formData.surplusInvoicePrice = num   //可开票金额
        this.orderDialog = false

        const val = this.orderDialogSelectTable[0].companyName
        const flag =  this.orderDialogSelectTable.every(ele => ele.companyName === val)
        this.formData.account = val
        this.formData.content = ''
        if (!flag) {
            this.$message.error('所选订单的收款账户不一致')
        }
        this.getFinanceInvoiceContent()
    }

    getFinanceInvoiceContent() {
        if (this.formData.account) {
            this.makeInvoiceContent = []
            getFinanceInvoiceContent({
                companyName: this.formData.account
            }).then((res: any) => {
                res.financeInvoiceContent.forEach((item) => {
                    if (item.types == this.formData.content) {
                        this.contentName = item.content
                    }
                    this.makeInvoiceContent.push({
                        label: item.content,
                        value: item.types,
                    })
                })
            })
        } else {
            this.$message.error('请选择收款账户')
        }
    }
    // 订单列表取消
    handleOrderDialog() {
        this.orderDialogSelectTable.map(item => {
            this.tableData.map(items => {
                if (item.financeOrderId !== items.financeOrderId) {
                    const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
                    orderDialogTable.clearSelection()
                }
            })
        })

        if (this.tableData.length > 0) {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            this.tableData.forEach(row => {
                orderDialogTable.toggleRowSelection(row, true)
            });
        } else {
            const orderDialogTable = this.$refs.orderDialogTable as HTMLFormElement
            orderDialogTable.clearSelection()
        }
        this.orderDialog = false
    }

    receivableDialogConfirm() {
        // let num = 0
        // this.orderDialogSelectTable.map(item => num += Number(item.surplusInvoicePrice ? item.surplusInvoicePrice : 0))
        // this.formData.surplusInvoicePrice = num   //可开票金额

        if (this.formData.basis == '1' || this.formData.basis == '回款编号') {
            this.formData.code = this.receivableDialogSelectTable.financeBackMoneyCode   //回款编号1
        }

        this.receivableConfirmList = this.receivableDialogSelectTable  //存数据取消选中状态
        if (this.receivableDialogSelectTable.financeInvoiceDetailList) {

            const arr = this.receivableDialogSelectTable.financeInvoiceDetailList
            let AllThisPrice = 0
            this.tableData = arr.map((item, index) => {
                AllThisPrice += Number(Number(item.financeOrderPrice) - Number(item.financeInvoicePrice))
                return Object.assign(item, {thisTimePrice: Number(item.financeOrderPrice) - Number(item.financeInvoicePrice)})
                // 减退款
            })
            this.formData.surplusInvoicePrice = Number(this.receivableDialogSelectTable.surplusInvoicePrice) - AllThisPrice;
        } else {
            this.tableData = []
        }


        const val = this.receivableDialogSelectTable.companyName
        this.formData.account = val
        this.formData.content = ''
        this.getFinanceInvoiceContent()
        this.receivableDialog = false
    }

    // 回款列表取消
    handleReceivableDialog() {
        if (!this.receivableConfirmList || (this.receivableConfirmList.financeBackMoneyId != this.receivableDialogSelectTable.financeBackMoneyId)) {
            const receivableTable = this.$refs.receivableDialogTable as HTMLFormElement
            receivableTable.clearSelection()
            receivableTable.toggleRowSelection(this.receivableConfirmList, true)
        }
        if (this.receivableDialogSelectTable) {
            const receivableTable = this.$refs.receivableDialogTable as HTMLFormElement
            receivableTable.toggleRowSelection(this.receivableDialogSelectTable, true)
        }
        this.receivableDialog = false
    }

    receivableDialogSelectionChange(selectionArr: any[]) {
        if (selectionArr.length > 0) {
            this.receivableDialogSelectTable = JSON.parse(JSON.stringify(selectionArr[0]))
            if (selectionArr.length > 1) {
                const receivableTable = this.$refs.receivableDialogTable as HTMLFormElement
                receivableTable.clearSelection()
                receivableTable.toggleRowSelection(selectionArr.pop())
            }
        } else {
            for (const key in this.receivableDialogSelectTable) {
                this.receivableDialogSelectTable[key] = null
            }
        }
    }

    handleReceivableClick(row) {
        if (row.surplusInvoicePrice > 0) {//可勾选
            (this.$refs.receivableDialogTable as HTMLFormElement).toggleRowSelection(row)
        }
    }

    handleSizeChange(val) {
        this.limit = val
        this.getOrderListOrMarketCoopetationId()
    }

    orderDialogPageChange(page: number) {
        this.orderDialogPage = page
        this.getOrderListOrMarketCoopetationId()
    }

    receivableDialogPageChange(page: number) {
        this.receivableDialogPage = page
    }

    // 选择订单可回款金额为0禁止选择
    selectOrder(row) {
        if (row.surplusInvoicePrice > 0) {
            return true  //可勾选
        } else {
            return false  //不可勾选
        }
    }

    // 选择回款可回款金额为0禁止选择
    selectReceivable(row) {
        if (row.surplusInvoicePrice > 0) {
            return true  //可勾选
        } else {
            return false  //不可勾选
        }
    }

    thisBackMoneyChange(row, val) {
        val = this.handleOninput(val, '2')
        row.thisTimePrice = this.handleOninput(val,'2')
        const num = 0
        // this.formData.surplusInvoicePrice = row.financeOrderPrice - row.financeInvoicePrice - row.thisTimePrice
        let allAlreadyMaceInvoice = 0
        let allOrderAmount = 0
        let allThisAmount = 0
        let allLastAmount = 0
        this.tableData.forEach((item, index) => {
            allOrderAmount = math.number(math.add(math.bignumber(allOrderAmount), math.bignumber(Number(item.financeOrderPrice))))
            allAlreadyMaceInvoice = math.number(math.add(math.bignumber(allAlreadyMaceInvoice), math.bignumber(Number(item.financeInvoicePrice))))
            allThisAmount = math.number(math.add(math.bignumber(allThisAmount), math.bignumber(Number(item.thisTimePrice))))
            allLastAmount = math.number(math.add(math.bignumber(allLastAmount), math.bignumber(Number(item.price))))

            if (item.financeOrderId === row.financeOrderId) {

                let maxPrice = 0
                // isShow == 1 -> 已通过
                if (this.isShow == '1') {
                    // 本次最大可开票金额（每一条数据---item）
                    maxPrice = math.number(math.subtract(math.bignumber(item.financeOrderPrice), math.bignumber(Number(item.financeInvoicePrice))))
                    if (Number(val) > Number(maxPrice)) {
                        this.$message.error('本次开票金额不能大于可开票金额')
                    }
                } else {
                    // 本次开票金额小于等于可开票金额
                    maxPrice = math.number(math.subtract(math.bignumber(item.financeOrderPrice), math.bignumber(Number(item.financeInvoicePrice))))

                    if (Number(val) > Number(maxPrice)) {
                        this.$message.error('本次开票金额不能大于可开票金额')
                    }
                }

                const tmpObj = this.tableData[index];
                this.$set(this.tableData, index, tmpObj);
            }

        })

        /*
        * 可开票金额
        * 已通过： 可开票金额 = 订单金额 - 已开票金额 - 本次开票金额
        * 未通过：可开票金额 = 订单金额 - 已开票金额 + 上次开票金额（price）- 本次开票金额 */
        const val11 = math.number(math.subtract(math.bignumber(allOrderAmount), math.bignumber(allAlreadyMaceInvoice)))
        this.formData.surplusInvoicePrice = math.number(math.subtract(math.bignumber(val11), math.bignumber(allThisAmount)))

    }

    // 学生本次开票金额input(4.8新需求迭代废弃)
    thisAmountInvoiceChange(val) {
        if (this.status == '已通过') {
            this.formData.surplusInvoicePrice = Number(this.maxPrice) - Number(this.formData.thisTimePrice)
            if (val > this.maxPrice) {
                this.$message.error('本次开票金额不能大于最大开票金额')
                return
            }
        } else {
            if (val > Number(this.formData.surplusInvoicePrice)) {
                this.$message.error('本次开票金额不能大于可开票金额')
                return
            }
        }
        this.formData.thisTimePrice = val

        const arr = this.tableData
        this.tableData = arr.map((item, index) => {
            return Object.assign(item, {thisTimePrice: val})
        })
    }

    // 负责人change
    async directorUserIdChange() {
        if (this.formData.directorUserId === '1') return
        getDepartmentByUserId(this.formData.directorUserId).then((res: any) => {
            this.formData.directorDepartmentlName = res.departmentName
        })
    }

    // 详情
    async getFinanceInvoiceById() {
        const res: any = await getFinanceInvoiceById({id: this.invoiceId, isUpdatedData: this.$route.query.isUpdatedData as string});
        this.formData = res.financeInvoice
        //    审批流程
        this.activities = res.financeInvoice.messageReviewList

        this.formData.thisTimePrice = res.financeInvoice.financeInvoiceDetailList[0].price
        this.invoiceNumTitle = this.formData.basis + '：'
        this.maxPrice = Number(this.formData.surplusInvoicePrice) + Number(this.formData.thisTimePrice)
        const arr = res.financeInvoice.financeInvoiceDetailList
        this.isShow = res.financeInvoice.isShow
        this.statusbyget = res.financeInvoice.status

        this.getFinanceInvoiceContent()
        let allThisTimePrice = 0
        this.tableData = arr.map((item, index) => {
            allThisTimePrice += Number(item.price)
            return Object.assign(item, {
                thisTimePrice: item.price,
                oldThisBackMoney: this.isShow == '1' ? item.price : 0,
                oldSurMoney: this.isShow == '1' ? res.financeInvoice.surplusInvoicePrice : 0,
                surplusInvoicePrice: this.isShow == '1' ? res.financeInvoice.surplusInvoicePrice : 0
            })
        })
        let val1 =math.number(math.subtract(math.bignumber(Number(res.financeInvoice.surplusInvoicePrice)),math.bignumber(Number(allThisTimePrice))));
        this.formData.surplusInvoicePrice = this.isShow == '1' || (this.isShow == '0' && this.statusbyget == '0') ? res.financeInvoice.surplusInvoicePrice : val1


        // 如果当前开票审批通过，在验证本次开票金额是否正确的时候就需要将本次开票的金额一起验证

        this.logList = res.financeInvoice.financeRefundLogList
        if (this.showInput) {
            this.formData.types = this.formData.types === '增值税普通发票' ? '1' : '0'
            this.formData.titleTypes =  this.formData.titleTypes === '个人/非企业单位' ? '1' : '0'
        }
        this.$nextTick(() => {
            // this.getOrderListOrMarketCoopetationId() //订单/回款列表
        })

    }

    changeTitleTypes(val) {
        this.formData.types = ''
    }

    // 编辑保存
    saveEditInvoice() {
        const obj = {
            id: this.formData.id,
            account: this.formData.account,  //收款账户 允许值: '苏州', '北京', '广州', '上海'
            isProof: this.formData.isProof,  //是否生成凭证   允许值: 0-否, 1-是
            remark: this.formData.remark,  //备注
            directorUserId: this.formData.directorUserId, //负责人id
            financeInvoiceDetailList: [],
            invoiceType: this.formData.types,  //开票类型 允许值: 0-增值税专用票, 1-普通发票
            invoiceTitle: this.formData.title,  //开票抬头 当mainPart = 0时必需
            invoiceCode: this.formData.invocieCode, //纳税识别号 当mainPart = 0时必需
            invoiceBank: this.formData.bank,  //开户行 当mainPart = 0时必需
            invoiceAccount: this.formData.invoiceAccount,   //开户账号 当mainPart = 0时必需
            invoiceAddress: this.formData.address,   //开票地址  当mainPart = 0时必需
            invoicePhone: this.formData.phone,   //电话 当mainPart = 0时必需
            invoiceContent: this.formData.content,   //开票内容
            // invoiceAt: this.formData.invoiceAt, //财务开票时间
            invoiceEmail: this.formData.email, //发票接收邮箱
            titleTypes: this.formData.titleTypes, //抬头类型
        }
        obj.financeInvoiceDetailList = this.tableData.map(item => ({
            financeOrderId: item.financeOrderId,
            thisTimePrice: String(item.thisTimePrice)
        }));


        for (const key in obj) {
            if (!obj[key] || obj[key].length === 0) {
                if (key !== 'invoiceEmail'&& key !== 'invoiceBank'&& key !== 'invoiceAccount'&& key !== 'invoiceAddress'&& key !== 'invoicePhone' && key !== 'invoiceCode') {
                    delete obj[key]
                }
            }
        }

            (this.$refs.ruleForm as HTMLFormElement).validate((valid: boolean) => {
                if (valid) {
                    const bol = this.tableData.some(item => item.thisTimePrice)
                    if (!bol) {
                        this.$message.error('请输入本次开票金额')
                        return
                    }
                    this.disableBtn = true
                    setFinanceInvoiceById(obj).then(() => {
                        this.$message.success('编辑成功')
                        setTimeout(() => {
                            window.close()
                            this.$router.push({
                                path: 'invoice',
                                query: {}
                            })
                        }, 1500)
                    }).catch((err: Error) => {
                        if (err.message === '审批流报错') {
                            this.errorDialogShow = true
                        }
                        this.disableBtn = false
                    })
                }
            })
    }

    closePage() {
        window.close()
    }

    handleChangeInvoice(val) {
        this.formData.isProof = val;
    }

    handleChangeType(val) {
        this.formData.types = val;
    }

    handleChangeContent(val) {
        this.formData.content = val;
    }

    edit() {
        this.showInput = true
        if (this.showInput) {
            this.formData.types = this.formData.types === '增值税普通发票' ? '1' : '0'
            this.formData.titleTypes = this.formData.titleTypes === '个人/非企业单位' ? '1' : '0'
        }
    }

    reseat() {
        this.cancelTabkBackClueDialog = false
        this.cancelTabkBackRepeatDialog = false
    }




    @Watch('UserName', {deep: true})
    changepageType(val: any) {
        if (val && !this.$route.query.id) {
            this.formData.createdUserRealName = this.UserName
        }
    }

    @Watch("directorUserId", {deep: true})
    handle(userId: string) {
        this.formData.directorUserId = userId
        if (userId !== '1') {
            this.directorUserIdChange()
        }
    }
}
